export default __webpack_public_path__ + "static/media/carousel3.50eda19f.jpg";